/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cursor_AddInputs */

const en_mcp_cursor_add = /** @type {(inputs: Mcp_Cursor_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add this entry to mcpServers in ~/.cursor/mcp.json, or in .cursor/mcp.json for a single project.`)
};

const es_mcp_cursor_add = /** @type {(inputs: Mcp_Cursor_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade esta entrada a mcpServers en ~/.cursor/mcp.json, o en .cursor/mcp.json para un solo proyecto.`)
};

/**
* | output |
* | --- |
* | "Add this entry to mcpServers in ~/.cursor/mcp.json, or in .cursor/mcp.json for a single project." |
*
* @param {Mcp_Cursor_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cursor_add = /** @type {((inputs?: Mcp_Cursor_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cursor_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cursor_add(inputs)
	return en_mcp_cursor_add(inputs)
});